import { createSelector } from 'selectors'

import { constant } from './resizable-editor.constant'

const getContent = () => createSelector<HTMLDivElement>({ selector: constant.selector.content })

const getAsides = () => createSelector<NodeListOf<HTMLElement>>({ selector: constant.selector.aside }, true)
const getSplitters = () => createSelector<NodeListOf<HTMLElement>>({ selector: constant.selector.splitter }, true)

export const resizableEditorSelectors = {
	getContent,
	getAsides,
	getSplitters,
}
